import { render } from "./StoricoCambioAnagrafica.vue?vue&type=template&id=072c1548&scoped=true"
import script from "./StoricoCambioAnagrafica.vue?vue&type=script&lang=js"
export * from "./StoricoCambioAnagrafica.vue?vue&type=script&lang=js"

import "./StoricoCambioAnagrafica.vue?vue&type=style&index=0&id=072c1548&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072c1548"]])

export default __exports__